import Dropdown from "../../components/Dropdown"
import DateRangeControl from "../../components/DateRangeControl"

export const statusOptions = ["All", "Success", "Errored"]

const clearButtonClass =
  "px-6 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition-colors text-sm font-medium disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400"

/*
  The filter card.

  An active accession search overrides the filters rather than combining with
  them, so while one is set every filter is disabled and blanked, with a title
  saying how to get them back.

  Do not wrap this in an `overflow-hidden` container: the date range's
  calendar popover would be clipped by it.
*/
const VideoLogsFilterBar = ({
  dateRangeCustomLabel,
  dateRangePresets,
  dateRangeTriggerLabel,
  dateRangeValue,
  status,
  patientIssuer,
  issuerOptions,
  searchTerm,
  isSearchActive,
  onGetDateRangeCustomSeed,
  onSelectDateRangePreset,
  onApplyCustomDateRange,
  onStatus,
  onPatientIssuer,
  onSearchTerm,
  onSearch,
  onClearSearch,
  onClearFilters,
}) => {
  const disabledTitle = isSearchActive
    ? "Clear the search field to enable filters"
    : null

  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      <div className="flex flex-wrap gap-4">
        <div
          className={isSearchActive ? "pointer-events-none opacity-40" : ""}
          title={disabledTitle || "Filter by date range"}
        >
          <label className="block text-xs font-medium mb-1 ml-1">
            DATE RANGE
          </label>
          <DateRangeControl
            customLabel={dateRangeCustomLabel}
            getCustomSeed={onGetDateRangeCustomSeed}
            presets={dateRangePresets}
            triggerLabel={dateRangeTriggerLabel}
            value={dateRangeValue}
            onApplyCustom={onApplyCustomDateRange}
            onSelectPreset={onSelectDateRangePreset}
          />
        </div>

        <div>
          <Dropdown
            disabled={isSearchActive}
            label="STATUS"
            options={isSearchActive ? [""] : statusOptions}
            setValue={onStatus}
            title={disabledTitle || "Filter by success/error status"}
            value={isSearchActive ? "" : status}
          />
        </div>

        <div>
          <Dropdown
            disabled={isSearchActive}
            label="PATIENT ISSUER"
            options={isSearchActive ? [""] : issuerOptions}
            setValue={onPatientIssuer}
            title={disabledTitle || "Filter by patient issuer"}
            value={isSearchActive ? "" : patientIssuer}
          />
        </div>

        <div className="flex items-end gap-2">
          <button
            className={clearButtonClass}
            disabled={isSearchActive}
            title={disabledTitle || "Clear all filters"}
            onClick={onClearFilters}
          >
            Clear
          </button>
        </div>

        <div className="flex-1" />

        <div className="flex items-end gap-2">
          <div>
            <label className="block text-xs font-medium mb-1 ml-1 text-gray-700">
              ACCESSION NUMBER
            </label>
            <input
              className="w-full min-w-[300px] px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
              placeholder="e.g. AN-2026-00142"
              type="text"
              value={searchTerm}
              onChange={(event) => onSearchTerm(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault()
                  onSearch()
                }
              }}
            />
          </div>
          <button
            className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm font-medium disabled:cursor-not-allowed disabled:bg-blue-400"
            onClick={onSearch}
          >
            Search
          </button>
          <button className={clearButtonClass} onClick={onClearSearch}>
            Clear
          </button>
        </div>
      </div>
    </div>
  )
}

export default VideoLogsFilterBar
